import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { Paper, Table } from 'redpoints-front-components/index';

import { auditResultsFetchIncidentsComparison } from '../../../actions/auditResultsActions';
import {
  getAuditResultsAppliedAuditorAssetId,
  getAuditResultsIsLoading,
  getAuditResultsResponseData,
} from '../../../reducers/assetAudit/auditResults';
import AuditResultsTableActions from './AuditResultsTableActions';
import {
  buildPageable,
  DEFAULT_PAGINATION_SIZE_OPTIONS,
} from '../../../helpers/paginationHelper';
import {
  auditResultsColumns,
  getRowClassName,
} from './auditResultsTableHelper';

const AuditResultsTable = ({
  auditAssetId,
  auditResultsData,
  auditResultsFetchIncidentsComparison,
  isLoadingAuditResults,
}) => {
  const mustRenderFragment =
    (isEmpty(auditResultsData) && !isLoadingAuditResults) || !auditAssetId;
  const pagination = {
    current: auditResultsData?.number + 1,
    pageSize: auditResultsData?.size,
    pageSizeOptions: DEFAULT_PAGINATION_SIZE_OPTIONS,
    total: auditResultsData?.totalElements,
  };

  const handleChange = (
    { current, pageSize },
    _filters,
    { columnKey, order }
  ) => {
    const columnKeyCovertedToSort =
      columnKey === 'existsInTheAuditedAsset' ? 'auditedIncidentId' : columnKey;

    const pageable = buildPageable({
      columnKey: columnKeyCovertedToSort,
      current,
      order,
      pageSize,
    });

    auditResultsFetchIncidentsComparison({
      auditAssetId,
      pageable,
    });
  };

  if (mustRenderFragment) {
    return <></>;
  }

  return (
    <Paper>
      <Table
        className="audit-results-table"
        columns={auditResultsColumns}
        dataSource={auditResultsData?.content}
        loading={isLoadingAuditResults}
        onChange={handleChange}
        pagination={pagination}
        rowClassName={record => getRowClassName(record)}
        rowKey={({ auditAssetId }) => auditAssetId}
      />
      <AuditResultsTableActions />
    </Paper>
  );
};

const mapStateToProps = state => ({
  auditAssetId: getAuditResultsAppliedAuditorAssetId(state),
  auditResultsData: getAuditResultsResponseData(state),
  isLoadingAuditResults: getAuditResultsIsLoading(state),
});

export default connect(mapStateToProps, {
  auditResultsFetchIncidentsComparison,
})(AuditResultsTable);
